import React, { useRef } from 'react';
import { AlertCircleIcon, UploadIcon, StethoscopeIcon } from 'lucide-react';
interface PrescriptionUploadSidebarProps {
  onPrescriptionUpload?: (file: File) => void;
  onConsultDoctor?: () => void;
}
export function PrescriptionUploadSidebar({
  onPrescriptionUpload,
  onConsultDoctor
}: PrescriptionUploadSidebarProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Check file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        alert('File size must be less than 5MB');
        return;
      }
      // Check file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        alert('Please upload a valid file (JPG, PNG, or PDF)');
        return;
      }
      onPrescriptionUpload?.(file);
    }
  };
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  const handleConsultClick = () => {
    onConsultDoctor?.();
  };
  return <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-5053" data-mp="1nkluq8imo3f2">
      <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-5054" data-mp="19rvylb9dxi48">Prescription</h3>
      {/* Warning Message */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4 flex items-start gap-2" data-id="element-5055" data-mp="1er8t8i6hzthd">
        <AlertCircleIcon className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-5056" data-mp="22gtbeyutumpl" />
        <p className="text-xs text-gray-700 leading-relaxed" data-id="element-5057" data-mp="26hn19xrtybl4">
          To complete your order, please upload a valid prescription. Accepted
          formats: PDF or image (JPG/PNG).
        </p>
      </div>
      {/* Upload Button */}
      <button onClick={handleUploadClick} className="w-full bg-[#1E2B55] hover:bg-[#162041] text-white font-bold py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors mb-2" data-id="element-5058" data-mp="1xf43vt6tcr69">
        <UploadIcon className="w-5 h-5" data-id="element-5059" data-mp="lz5m90xkkwtf" />
        Upload Prescription
      </button>
      {/* File Size Info */}
      <p className="text-xs text-gray-500 text-right mb-4" data-id="element-5060" data-mp="3u36ijdto0p3t">
        Maximum file size: 5MB
      </p>
      {/* Divider Text */}
      <p className="text-sm text-gray-600 mb-3" data-id="element-5061" data-mp="3pbogsnjtikhs">
        You can request a prescription if you do not have one
      </p>
      {/* Consult Doctor Button */}
      <button onClick={handleConsultClick} className="w-full bg-white hover:bg-gray-50 text-gray-900 font-semibold py-3 px-4 rounded-lg border-2 border-gray-300 flex items-center justify-center gap-2 transition-colors" data-id="element-5062" data-mp="3kbkbltod1c6v">
        <StethoscopeIcon className="w-5 h-5" data-id="element-5063" data-mp="36cu5jojkc26d" />
        Request Prescription & Consult Doctor
      </button>
      {/* Hidden File Input */}
      <input ref={fileInputRef} type="file" accept="image/jpeg,image/jpg,image/png,application/pdf" onChange={handleFileChange} className="hidden" data-id="element-5064" data-mp="31gdealh2h7p2" />
    </div>;
}